import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import OfflineIndicator from './components/OfflineIndicator';
import Login from './pages/Login';
import Overview from './pages/Overview';
import Characters from './pages/Characters';
import Elements from './pages/Elements';
import Pillars from './pages/Pillars';
import PillarHierarchy from './components/PillarHierarchy';
import CardDetails from './components/CardDetails';
import Kanban from './pages/Kanban';
import Playmat from './pages/Playmat';
// imageLoader removed - using unified getImageUrl from imageUtils
import './App.css';

function AppContent() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  return (
    <div className="App">
      <OfflineIndicator />
      {!isLoginPage && <Header />}
      <main className={`main ${isLoginPage ? 'login-main' : ''}`}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Overview />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/characters" 
            element={
              <ProtectedRoute>
                <Characters />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/elements" 
            element={
              <ProtectedRoute>
                <Elements />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/pillars" 
            element={
              <ProtectedRoute>
                <Pillars />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/pillars/hierarchy/:l1Name" 
            element={
              <ProtectedRoute>
                <PillarHierarchy />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/character/:slug" 
            element={
              <ProtectedRoute>
                <CardDetails cardType="character" />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/element/:slug" 
            element={
              <ProtectedRoute>
                <CardDetails cardType="element" />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/pillar/:slug" 
            element={
              <ProtectedRoute>
                <CardDetails cardType="pillar" />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/kanban" 
            element={
              <ProtectedRoute>
                <Kanban />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/playmat" 
            element={
              <ProtectedRoute>
                <Playmat />
              </ProtectedRoute>
            } 
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  // Initialize optimized image loader
  useEffect(() => {
    // Image preloading handled by getImageUrl in imageUtils
  }, []);
  
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
